import { RequestService } from '../RequestService'
import { useEnvStore } from 'store'
import { isLocal } from 'utils'

/** Sumsub 活体认证请求服务 */
class SumSubRequest extends RequestService {
  constructor() {
    super()
  }

  protected setBaseUrl(): string {
    if (isLocal()) {
      return 'https://appuc.hxexchge.com'
    }
    const envStore = useEnvStore()
    return envStore.config?.appuc || ''
  }

  /**
   * 获取 Sumsub 访问 Token
   * POST /UCenter/Kyc/getHighKycToken
   */
  generateAccessToken() {
    return this.post<{
      token: string
      status: number
      level: number
      userId: number
      channelId: number
    }>('/UCenter/Kyc/getHighKycToken')
  }

  /**
   * 同步验证状态
   * POST /UCenter/Sumsub/syncStatus
   */
  syncVerificationStatus(data: { applicantId: string; applicationId?: string }) {
    return this.post<{
      status: 'pending' | 'completed' | 'failed'
      level: 1 | 2
      reviewResult?: any
    }>('/UCenter/Sumsub/syncStatus', data)
  }

  /**
   * 获取验证结果详情
   * POST /UCenter/Sumsub/getResult
   */
  getVerificationResult(data: { applicantId: string }) {
    return this.post<{
      verificationResult: any
      reviewStatus: string
      rejectLabels?: string[]
    }>('/UCenter/Sumsub/getResult', data)
  }
}

export const SumSubServices = new SumSubRequest()
